import { Component } from '@angular/core';
import {ModalController, NavController, NavParams, ViewController} from "ionic-angular";
import {Storage} from "@ionic/storage";
import {StockcartManager} from "../../providers/stockcart-manager";
import {GVLogger} from "../../services/gv-logger";
import {Api} from "../../providers/api";
import {ItemPage} from "../item-details/item-details";

@Component({
  selector: 'page-manage-bad-product-model',
  templateUrl: 'manage-bad-product-model.html',
})
export class ManageBadProductModelPage {

  items = [];
  cacheImages:any;
  private product: any;
  damagedProductComment = "";
  openedProductComment = "";
  damagedQuntity = 0;
  openedQuantity = 0;
  enteredQuantityInDamaged = 0;
  enteredQuantityInOpened = 0;
  badProductConditions;
  markBadList = [];
  totalQuantity = 0;


  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              private viewCtrl:ViewController,
              private storage:Storage,
              private stockCartManager: StockcartManager,
              private modalController:ModalController,
              private gVLogger: GVLogger,
              public api:Api) {
    this.items.push(this.navParams.get('item'));
    this.product = this.navParams.get('item');
    // this.badProductConditions = this.navParams.get('badProductConditions');
    // this.gVLogger.log("badProductConditions from nav params "  + JSON.stringify(this.badProductConditions) );

    for(let loc of this.product.productInventoryLocationsDTO){
      this.totalQuantity += loc.quantityRemaining;
      if(loc.productConditionCode === 0){
        if(loc.status === 1){
          this.product.quantity = loc.quantityReceived;
        }else {
          this.product.quantity = loc.quantityRemaining;
        }

      }
    }

    // for(let badInventory of this.badProductConditions){
    //   let badProductObj = {
    //       code:badInventory.code,
    //       type: badInventory.desctiption,
    //       quantity : 0,
    //       comment : ""
    //   };
    //   this.markBadList.push(badProductObj);
    // this.markBadList = this.product.markBadList;

    // }

    this.gVLogger.log("badProductConditions after allinment "  + JSON.stringify(this.product.markBadList) );
    // this.product.quantity = this.product.totalQuantityShipmentNotice;

    this.storage.get("cacheImages").then((cache)=>{
      this.cacheImages = cache;
    });
  }

  // totalBadQuantity(){
  //   let totalBad = 0;
  //   for(let bad of this.product.markBadList){
  //     totalBad += bad.quantity;
  //   }
  //   return totalBad;
  // }

  // totalGoodQuantity(){
  //   let totalBad = 0;
  //   for(let bad of this.product.markBadList){
  //     totalBad += bad.quantity;
  //   }
  //   return this.product.quantity - totalBad;
  // }

  ionViewDidLoad() {
    this.gVLogger.log('ionViewDidLoad ReceiveStockPopupPage');
  }

  close(){
    for(let loc of this.product.productInventoryLocationsDTO){
      loc.quantityReceived= loc.quantityRemaining;
    }
    this.viewCtrl.dismiss();
  }

  addProductToCartOnOk(){
    for(let loc of this.product.productInventoryLocationsDTO){
      this.totalQuantity += loc.quantityRemaining;
      if(loc.productConditionCode === 0){
        loc.status = 1;
        loc.quantityReceived = this.product.quantity;
      }
    }

    this.viewCtrl.dismiss(this.product.markBadList);
  }

  gotoSingleView(product){
    this.api.get("product/" + product.id + "/?isWebStore=" + 1).map(res => res.json()).subscribe(data => {
      if(data.status === "200"){
        product.description = data.data.description;
      }
    })
    this.navCtrl.push(ItemPage, {item: product, "status" : "fromReceiveStock"});
  }

  makeImageURL(dimensions,item){
    return this.stockCartManager.makeImageURL(dimensions,item);
  }

  imageNotFound(e,item){
    item.productImagesDTO[0].extension = "png";
    item.productImagesDTO[0].name = "dummy";
  }

  removeProductQuantityFromOpened(item){

    this.gVLogger.log("Quantity Received " + JSON.stringify(item));

    if(item.quantityReceived > 0){
      item.quantityReceived -= 1;
      this.product.quantity += 1;

    }

  }

  totalGoodQuantity(){
    let totalBad = 0;
    for(let loc of this.product.productInventoryLocationsDTO){
      if(loc.productConditionCode !== 0){
        totalBad += loc.quantityReceived;
      }
    }
    this.gVLogger.log("TotalBAd : " + totalBad);
    return this.totalQuantity - totalBad;
  }


  getTotalBadQuantity(){
    let totalBad = 0;
    for(let loc of this.product.productInventoryLocationsDTO){
      if(loc.productConditionCode !== 0){
        console.log("rrrr quantityReceived "+ loc.quantityReceived)

        if(parseInt(loc.quantityReceived) !== NaN && parseInt(loc.quantityReceived) !== undefined){
          let integerQuantityReceived = parseInt(loc.quantityReceived);

          console.log("integerQuantityReceived " + integerQuantityReceived);
          console.log("integerQuantityReceived totalBad" + totalBad);
          totalBad += integerQuantityReceived;
        }

        console.log("rrrr totalBad "+ totalBad)
      }
    }
    console.log("TotalBAd : " + totalBad);
    return totalBad;
  }


  updateProductQuantityToOpened(product){
    this.gVLogger.log("update called....." + product.quantityReceived);
    if(String(product.quantityReceived) !=""){
      if(String(product.quantityReceived).match(/^\d+$/)){
        this.gVLogger.log("update called....." + product.quantityReceived);
        let enteredQuantity = product.quantityReceived;
        product.quantityReceived = 0;
        this.product.quantity = this.totalGoodQuantity();

        if ( enteredQuantity <= this.product.quantity){
          product.quantityReceived = Number(enteredQuantity);
          this.product.quantity = this.totalGoodQuantity();
        }else {
          product.quantityReceived = 0;
        }

      }else{
        this.gVLogger.log("update called else 1....." + product.quantityReceived);

        product.quantityReceived = 0;

      }
    }else{
      this.gVLogger.log("update called else 2....." + product.quantity);

      product.quantityReceived = 0;

    }


  }

  addProductQuantityToOpened(item){
    if( this.product.quantity > 0){
      item.quantityReceived += 1;
      this.product.quantity -= 1;
    }

  }




}



// WEBPACK FOOTER //
// ./src/pages/manage-bad-product-model/manage-bad-product-model.ts